import accordion, { accordionVariants } from './accordion';
import banner, { bannerVariants } from './banner';
import buttonSize, { buttonSizeVariants } from './button-size';
import button, { buttonVariants } from './button';
import cards, { cardsVariants } from './cards';
import combobox, { comboboxVariants } from './combobox';
import featureGrid, { featureGridVariants } from './feature-grid';
import hero, { heroVariants } from './hero';
import heading, { headingVariants } from './heading';
import link, { linkVariants } from './link';
import logoSection, { logoSectionVariants } from './logo-section';
import nav, { navVariants } from './nav';
import paper, { paperVariants } from './paper';
import peopleSection, { peopleSectionVariants } from './people-section';
import quote, { quoteVariants } from './quote';
import tileSize, { tileSizeVariants } from './tile-size';
import video, { videoVariants } from './video';
import wave, { waveVariants } from './wave';

export const componentVariants = {
  accordion: accordionVariants,
  banner: bannerVariants,
  buttonSize: buttonSizeVariants,
  buttons: buttonVariants,
  card: cardsVariants,
  combobox: comboboxVariants,
  featureGrid: featureGridVariants,
  headings: headingVariants,
  hero: heroVariants,
  links: linkVariants,
  logoSection: logoSectionVariants,
  nav: navVariants,
  paper: paperVariants,
  peopleSection: peopleSectionVariants,
  quote: quoteVariants,
  tileSizes: tileSizeVariants,
  video: videoVariants,
  wave: waveVariants,
};

export {
  accordion,
  banner,
  buttonSize,
  button,
  cards,
  combobox,
  featureGrid,
  heading,
  hero,
  link,
  logoSection,
  nav,
  paper,
  peopleSection,
  quote,
  tileSize,
  video,
  wave,
};
